import ChatCard from '@/shared/chat-ui/ChatCard';
import { Button } from '@/shared/ui/button';
import { Home } from 'lucide-react';
import { useForm, useWatch } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { CreateThemeSchema, CreateThemeType } from '../types';
import { zodResolver } from '@hookform/resolvers/zod';
import CreateThemeForm from './CreateThemeForm';
import { CreateThemeSteps } from '..';

type Props = {
  setStep: (id: CreateThemeSteps) => void;
}

const CreateTheme = ({ setStep }: Props) => {

  const form = useForm<CreateThemeType>({
    resolver: zodResolver(CreateThemeSchema),
    defaultValues: {
      activity: "Post"
    }
  })

  const postType: "Post" | "Campaign" = useWatch({
    control: form.control,
    name: "activity"
  })

  const onGenerateHandler = (id: number) => {
    console.log(id, "post generated");
    
    if(postType === "Post"){
      // route to theme result
      console.log('routing to', id)
      navigate(`/home?curr=result&theme=${id}`)
    }
    if(postType === "Campaign"){
      // route to campaign stories
      navigate(`/home?curr=story&theme=${id}`)
    }
  }

  const navigate = useNavigate()

  return (
    <>
      <ChatCard user="client">
        <div className="w-full flex flex-col-reverse sm:flex-row justify-between items-end sm:items-center gap-3">

          <div className='flex items-center gap-1'>
            <Button
              onClick={() => navigate('/home?curr=navigation')}
              size="icon"
              variant="outline"
              className="rounded-full font-poppins border-2 border-purple-400 hover:bg-white tracking-wide text-purple-600"
            >
              <Home />
            </Button>
            <Button
              onClick={() => navigate('/home?curr=first')}
              variant="outline"
              className="rounded-full font-poppins border-2 border-purple-400 hover:bg-white tracking-wide text-purple-600"
            >
              Themes from siAi
            </Button>
          </div>
          <p className="tracking-wide text-gray-500 font-poppins text-sm">I want to check something new</p>
        </div>
      </ChatCard>
      <CreateThemeForm
        setStep={setStep}
        onGenerate={onGenerateHandler}
        createForm={form}
      />
    </>
  )
}

export default CreateTheme;
